<template>
  <section class="section-comingSoon">
    <div class="container">
      <header class="section-header mb-2">
        <div class="section-header-title">
          Coming Soon
          <!-- <img
            src="@/assets/img/gif/Mascots-momcorn-small.gif"
            height="63"
            width="50"
            alt
            class="home-gif-image"
          /> -->
        </div>
        <router-link
          v-if="!isLoadingComingSoonMovies && movies.length"
          class="d-none d-md-block"
          to
         @click.native="onClickedViewAll"
          >View all >>></router-link
        >
        <router-link
          v-if="!isLoadingComingSoonMovies && movies.length"
          class="d-md-none mobile-seeAll-btn"
          to
          @click.native="() => $router.push({ name: 'Movies' })"
          >See All</router-link
        >
      </header>

      <div>
        <component-content-loader v-if="isLoadingComingSoonMovies" />
        <div class="row" v-if="!isLoadingComingSoonMovies && movies.length > 0">
          <div
            v-for="(movies, comingSoonMoviesKey) in movies"
            :key="comingSoonMoviesKey"
            class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 evenSpacing"
          >
            <div class="movie-listing-card">
              <!-- <div class="release-date">{{ movies.Film_dtmOpeningDate }}</div> -->

              <div
                class="movie-card-img-box"
                @click="
                  () =>
                    $router.push({
                      name: 'Movie Details',
                      params: { movie_code: movies.Film_strCode }
                    })
                "
              >
                <img
                  v-lazy="IMAGE_URL + movies.image_path_1"
                  class="lazy-image img-fluid"
                  alt
                  style="cursor: pointer"
                />
              </div>

              <!-- SHOW ONLY ON MOBILE START -->
              <div class="mobile-heart-btn d-md-none">
                <button
                  class="btn-like"
                  title="Like this movie"
                  @click="
                    getIsUserLogged === true
                      ? handleLikeMovie($event, movies.Film_strCode)
                      : onHandleOpenModal('signInModal')
                  "
                >
                  <!-- :icon="movieLiked ? 'heart-fill' : 'heart'"
                      :variant="movieLiked ? 'danger' : 'secondary'"-->
                  <b-icon
                    :icon="
                      movies.liked === 'Y' || movies.movie_liked
                        ? 'heart-fill'
                        : 'heart'
                    "
                    :variant="
                      movies.liked === 'Y' || movies.movie_liked
                        ? 'danger'
                        : 'secondary'
                    "
                  ></b-icon>
                  <!-- <span>{{ movies && movies.likes }}</span> -->
                  <!-- {{ movie.movie_liked }} -->
                </button>
              </div>
              <!-- SHOW ONLY ON MOBILE END -->
              <div class="movie-content">
                <div class="movie-title">{{ movies.csm_film_title }}</div>

                <div class="coming-soon-movie-card d-none d-md-block">
                  <div class="movie-details-grid">
                    <div class="dot-list-1">
                      {{ movies.language_name }}<span></span>
                      {{ movies.genre_name }}<span></span>
                      {{ movies.Film_strCensor }}
                    </div>

                    <button
                      class="btn-like"
                      title="Like this movie"
                      @click="
                        getIsUserLogged === true
                          ? handleLikeMovie($event, movies.Film_strCode)
                          : onHandleOpenModal('signInModal')
                      "
                    >
                      <!-- :icon="movieLiked ? 'heart-fill' : 'heart'"
                      :variant="movieLiked ? 'danger' : 'secondary'"-->
                      <b-icon
                        :icon="
                          movies.liked === 'Y' || movies.movie_liked
                            ? 'heart-fill'
                            : 'heart'
                        "
                        :variant="
                          movies.liked === 'Y' || movies.movie_liked
                            ? 'danger'
                            : 'secondary'
                        "
                      ></b-icon>
                      <span>{{ movies && movies.likes }}</span>
                      <!-- {{ movie.movie_liked }} -->
                    </button>
                  </div>
                </div>

                <!-- SHOW ONLY ON MOBILE START -->
                <div class="d-md-none">
                  <ul class="dot-list">
                    <li>{{ movies.language_name }}</li>
                    <li>{{ movies.genre_name }}</li>
                    <li>{{ movies.Film_strCensor }}</li>
                  </ul>
                </div>
                <!-- SHOW ONLY ON MOBILE END -->

                <div class="d-none d-md-block mt-2">
                  <div class="row">
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-2 mb-sm-0 pr-sm-1"
                    >
                      <a
                        data-fancybox
                        :href="movies.youtube_url"
                        class="btn btn-outline-primary w-100"
                        >Play Trailer</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <EmptyMovieState
          v-if="!isLoadingComingSoonMovies && movies.length === 0"
          isClass="border-0"
          :emptyMessage="`No Movies Found`"
          :isNeedTopSpace="true"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MovieService from "@/apiServices/MovieService";
import { IMAGEURL } from "@/config";
import Vue from "vue";
export default {
  name: "comingSoon",
  data() {
    return {
      movies: [],
      movieLiked: false,
      IMAGE_URL: IMAGEURL,
      isLoadingComingSoonMovies: false
    };
  },
  beforeMount() {
    this.getComingSoonMovies();
  },
  computed: {
    ...mapGetters(["getIsUserLogged"])
  },
  methods: {
    ...mapActions(["onHandleOpenModal"]),
    async getComingSoonMovies(params = {}) {
      // let loader = Vue.$loading.show();
      try {
        this.isLoadingComingSoonMovies = true;
        this.movies = [];
        const response = await MovieService.ComingSoonMovies(params);
        const { data } = response;
        if (data && data.status) {
          this.movies = data.data;
        }
      } catch (error) {
        // PLEASE SHOW POP UP HERE IF GOT FAILED
      } finally {
        setTimeout(() => (this.isLoadingComingSoonMovies = false), 500);
        // loader.hide();
      }
    },
    async handleLikeMovie(e, movie_code) {
      console.log(e);
      console.log(movie_code);
      if (movie_code) {
        const response = await MovieService.LikeMovie({ movie_code });
        const { data } = response;
        if (data && data.status) {
          if (data.data === "unliked") {
            console.log("movie unlike success");
            const index = this.movies.findIndex(
              movie => movie.Film_strCode === movie_code
            );
            if (index > -1) {
              console.log("index", index);
              this.movies[index].movie_liked = false;
              this.movies[index].likes = this.movies[index].likes - 1;
              this.movies[index].liked = "N";
              this.$forceUpdate();
            }
          } else {
            console.log("movie like success");
            const index = this.movies.findIndex(
              movie => movie.Film_strCode === movie_code
            );
            if (index > -1) {
              console.log("index", index);
              this.movies[index].movie_liked = true;
              this.movies[index].likes = this.movies[index].likes + 1;
              console.log("this.movies[index] :>> ", this.movies[index]);
              this.$forceUpdate();
            }
          }
        }
      }
    },
    onClickedViewAll() {
      sessionStorage.setItem('movie_path','coming_soon');
      this.$router.push({ name: 'Movies' });
    }
  }
};
</script>

<style scoped>
.section-comingSoon {
  padding-top: 30px;
  padding-bottom: 30px;
}
.lazy-image {
  width: 264px;
  height: 319px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/comingSoon.vue